import { useContext } from "react";
import { ToastContext } from "../context/ToastContext";
import { environment } from "../config/environment";
import { useSWRFetcher } from "./useSWRFetcher";
import useSWRMutation from "swr/mutation";
import { EmailActionResponseModel } from "../models/EmailActionModels";
import { AddEmailAction, ReassignEmailAction } from "../models/EmailActionModels";
import { useEmailId } from "./useEmailId";

export const useAddEmailAction = () => {
  const fetcher = useSWRFetcher();
  const { showToast } = useContext(ToastContext);
  const emailId = useEmailId();

  const { trigger, isMutating, error } = useSWRMutation(
    `${environment.apiUrl}/api/emails/actions`,
    (url: string, { arg }: { arg: AddEmailAction }) =>
      fetcher<EmailActionResponseModel>(url, {
        method: "POST",
        body: JSON.stringify(arg),
      }),
    {
      onError: () => {
        showToast("Failed to add email action, please try again later", "error");
      },
    }
  );

  const { trigger: reAssignEmailAction } = useSWRMutation(
    `${environment.apiUrl}/api/emails/actions/${emailId}/assign`,
    (url: string, { arg }: { arg: ReassignEmailAction }) =>
      fetcher<EmailActionResponseModel>(url, {
        method: "POST",
        body: JSON.stringify(arg),
      }),
    {
      onError: () => {
        showToast("Failed to reassign email action, please try again later", "error");
      },
    }
  );
  return {
    addEmailAction: trigger,
    reAssignEmailAction,
    isLoading: isMutating,
    isError: !!error,
  };
};
